"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SearchBarDesktop = _interopRequireDefault(require("./SearchBarDesktop"));

var _SearchBarMobile = _interopRequireDefault(require("./SearchBarMobile"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const SearchBar = ({
  onSearch,
  options,
  mobile
}) => {
  const [option, setOption] = (0, _react.useState)('');
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    if (option === '') {
      setSearchTerm('');
    }
  });

  const handleSelectChange = event => {
    setOption(event.target.value.toString());
    setSearchTerm('');
  };

  const handleSubmit = event => {
    if (event.key === 'Enter' && event.target.value.length >= options[option].minLength) {
      onSearch(event.target.value, options[option].value);
      setOption('');
    }
  };

  const handleSubmitOnClick = () => {
    if (searchTerm.length >= options[option].minLength) {
      onSearch(searchTerm, options[option].value);
      setOption('');
    }
  };

  const handleInputChange = event => setSearchTerm(event.target.value);

  const SearchBarComponent = mobile ? _SearchBarMobile.default : _SearchBarDesktop.default;
  return /*#__PURE__*/_react.default.createElement(SearchBarComponent, {
    handleSelectChange: handleSelectChange,
    handleSubmit: mobile ? handleSubmitOnClick : handleSubmit,
    handleInputChange: handleInputChange,
    currentOption: option,
    currentSearchTerm: searchTerm,
    options: options
  });
};

SearchBar.propTypes = {
  onSearch: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  mobile: _propTypes.default.bool
};
SearchBar.defaultProps = {
  onSearch: () => null,
  mobile: false
};
var _default = SearchBar;
exports.default = _default;